import packageJson from '../../package.json';

export default function getPackageList() {
  try {
    // Destructure dependencies, devDependencies, and peerDependencies from package.json
    const { dependencies, devDependencies, peerDependencies } = packageJson;

    // Extract the names of dependencies
    const dependencyNames = dependencies ? Object.keys(dependencies) : [];

    // Extract the names of devDependencies
    const devDependencyNames = devDependencies ? Object.keys(devDependencies) : [];

    // Extract the names of peerDependencies
    const peerDependencyNames = peerDependencies ? Object.keys(peerDependencies) : [];

    // Combine all dependencies into one array
    const allPackages = [...dependencyNames, ...devDependencyNames, ...peerDependencyNames];

    // Log the list of packages
    console.log('List of Packages:', allPackages);

    return allPackages;
  } catch (jsonError) {
    console.error('Error parsing package.json:', jsonError);
    return [];
  }
}
